<template>
  <div ref="captcha" class="captcha"></div>
</template>

<script src="./captcha.js"></script>
<style src="./captcha.scss" lang="scss"></style>
